'use client'

import { Button, Typography, Stack, Box } from '@mui/material'

import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined'
import UploadFileIcon from '@mui/icons-material/UploadFile'

import { useTranslation } from '@theme/base/contexts'

export interface PageTitleProps {
  title: string
  marginBottom?: number
  subtitle?: string | undefined
  addUrl?: string | undefined
  addText?: string | undefined
  children?: React.ReactNode
}

const PageTitle = ({ title, marginBottom = 6, subtitle, addUrl, addText, children }: PageTitleProps) => {
  const { getTranslation } = useTranslation()
  return (
    <>
      <Stack direction={{ md: "row" }} alignItems={{ md: "center" }} justifyContent="space-between" mb={marginBottom}>
        <Typography component="h1" variant="size16" fontWeight="600" sx={{ fontSize: { xs: '32px', md: '40px' } }}>
          {title}
        </Typography>
        {children}
        {addUrl && (
          <Button variant="contained" color="secondary" size='large' href={addUrl} endIcon={<UploadFileIcon />}>
            <Typography variant="size16" textTransform="capitalize">
              {addText || getTranslation('button.add')}
            </Typography>
          </Button>
        )}
        
      </Stack>
      {subtitle && (
        <Box mb={10}>
          <Typography component="p" variant="size24">
            {subtitle}
          </Typography>
        </Box>
      )}
    </>
  )
}

// Subcomponente para el contenido
const PageTittleButtons: React.FC<{ children: React.ReactNode }> = ({ children }) => <div style={{ padding: '1rem' }}>{children}</div>

PageTitle.Buttons = PageTittleButtons

export default PageTitle
